import React from 'react';
import ReactDOM from 'react-dom/client';
import FeedWidget from './Feed/components/FeedWidget';
import Blog from './Blog/components/Blog';
import Events from './Events/components/Events';
import UpcomingEventsSidebar from './UpcomingEventsSidebar/UpcomingEventsSidebar';
import SearchWidget from './Search/components/SearchWidget';
import FAQs from './FAQ/components/FAQs';
import BlogCategories from './BlogCategories/components/List';
import RelatedBlogPosts from './RelatedBlogPosts/components/RelatedBlogPosts';
import CarouselWidget from './Carousel/CarouselWidget';
import FloatingFeaturesWidget from './FloatingFeatures/FloatingFeaturesWidget';
import type { Section } from './FloatingFeatures/FloatingFeaturesWidget';
import { mountBlogOverview } from './BlogOverview/mount';

// blog overview (filter bar + one feed per category)
mountBlogOverview();

// feeds
if (document.querySelectorAll('.widget-feed').length) {
    document.querySelectorAll('.widget-feed').forEach(element => {
        if (element.children.length) {
            const childNode = element.querySelector('.feed-items');

            // data params
            const allowedContentTypes = childNode?.getAttribute('data-allowedContentTypes');
            const sources = childNode?.getAttribute('data-sources');
            const pageSize = childNode?.getAttribute('data-pageSize');
            const pageId = childNode?.getAttribute('data-pageId');
            const itemCount = childNode?.getAttribute('data-itemCount');
            const query = childNode?.getAttribute('data-query');
            const sortBy = childNode?.getAttribute('data-sortBy');
            const startDate = childNode?.getAttribute('data-startDate');
            const endDate = childNode?.getAttribute('data-endDate');
            const categories = childNode?.getAttribute('data-categories');
            const itemsPerRowSmall = childNode?.getAttribute('data-itemsPerRowSmall');
            const itemsPerRowMedium = childNode?.getAttribute('data-itemsPerRowMedium');
            const itemsPerRowLarge = childNode?.getAttribute('data-itemsPerRowLarge');
            const emptyMessage = childNode?.getAttribute('data-emptyMessage');
            const defaultImage = childNode?.getAttribute('data-defaultImage');

            const root = ReactDOM.createRoot(
                childNode ?? document.getElementsByClassName('.feed-items')[0] as HTMLElement
            );

            root.render(
                <React.StrictMode>
                    <FeedWidget
                        items={null}
                        emptyMessage={emptyMessage ?? ''}
                        allowedContentTypes={allowedContentTypes ? allowedContentTypes.split(',') : null}
                        sources={sources ? sources.split(',') : []}
                        pageSize={pageSize ? parseInt(pageSize) : 0}
                        pageId={pageId ? parseInt(pageId) : 0}
                        itemCount={itemCount ? parseInt(itemCount) : 0}
                        query={query ?? ''}
                        sortBy={sortBy ?? ''}
                        startDate={startDate ? new Date(startDate) : null}
                        endDate={endDate ? new Date(endDate) : null}
                        categories={categories ? categories.split(',') : null}
                        itemsPerRowSmall={itemsPerRowSmall ? parseInt(itemsPerRowSmall) : 1}
                        itemsPerRowMedium={itemsPerRowMedium ? parseInt(itemsPerRowMedium) : 1}
                        itemsPerRowLarge={itemsPerRowLarge ? parseInt(itemsPerRowLarge) : 1}
                        defaultImage={defaultImage ?? ''} />
                </React.StrictMode>
            );
        }
    });
}

// blog posts
if (document.getElementById('blogPostListing')) {
    const source = document.getElementById('blogPostListing')?.getAttribute('data-source');
    const root = ReactDOM.createRoot(
        document.getElementById('blogPostListing') as HTMLElement
    );

    root.render(
        <React.StrictMode>
            <Blog source={source ? parseInt(source) : 0} />
        </React.StrictMode>
    );
}

// event listing
if (document.getElementById('eventListing')) {
    const elem = document.getElementById('eventListing');
    const source = elem?.getAttribute('data-source');
    const defaultImage = elem?.getAttribute('data-defaultImage');
    const pageSize = elem?.getAttribute('data-pageSize');
    const numberOfMonths = elem?.getAttribute('data-numberOfMonths');
    const resultMessage = elem?.getAttribute('data-resultmessage');
    const noResultMessage = elem?.getAttribute('data-noresultmessage');

    const root = ReactDOM.createRoot(
        document.getElementById('eventListing') as HTMLElement
    );

    root.render(
        <React.StrictMode>
            <Events source={source ? parseInt(source) : 0}
                pageSize={pageSize ? parseInt(pageSize) : 0}
                numberOfMonths={numberOfMonths ? parseInt(numberOfMonths) : 0}
                defaultImage={defaultImage ?? ''}
                resultMessage={decodeURI(resultMessage ?? 'Search Results for "[searchTerm]"')}
                noResultMessage={decodeURI(noResultMessage ?? 'No results found for "[searchTerm]"')} />
        </React.StrictMode>
    );
}

// upcoming event sidebar
if (document.getElementById('upcomingEventSidebar')) {
    const elem = document.getElementById('upcomingEventSidebar');
    const source = elem?.getAttribute('data-source');
    const numberOfMonths = elem?.getAttribute('data-numberOfMonths');

    const root = ReactDOM.createRoot(
        document.getElementById('upcomingEventSidebar') as HTMLElement
    );

    root.render(
        <React.StrictMode>
            <UpcomingEventsSidebar source={source ? parseInt(source) : 0}
                numberOfMonths={numberOfMonths ? parseInt(numberOfMonths) : 0} />
        </React.StrictMode>
    );
}

// search
if (document.querySelectorAll('.widget-search-results').length) {
    document.querySelectorAll('.widget-search-results').forEach(element => {
        if (element.children.length) {
            const childNode = element.children[0];

            // data params
            const pageSize = childNode.getAttribute('data-pageSize');
            const resultMessage = childNode.getAttribute('data-resultmessage');
            const noResultMessage = childNode.getAttribute('data-noresultmessage');

            const root = ReactDOM.createRoot(
                childNode
            );

            root.render(
                <React.StrictMode>
                    <SearchWidget pageSize={pageSize ? parseInt(pageSize) : 0}
                        resultMessage={decodeURI(resultMessage ?? 'Search Results for "[searchTerm]"')}
                        noResultMessage={decodeURI(noResultMessage ?? 'No results found for "[searchTerm]"')} />
                </React.StrictMode>
            );
        }
    });
}

// faq
if (document.querySelectorAll('.widget-faq').length) {
    document.querySelectorAll('.widget-faq').forEach(element => {
        if (element.children.length) {
            const childNode = element.children[0];

            // data params
            const source = childNode.getAttribute('data-source');
            const resultMessage = childNode.getAttribute('data-resultmessage');
            const noResultMessage = childNode.getAttribute('data-noresultmessage');

            const root = ReactDOM.createRoot(
                childNode
            );

            root.render(
                <React.StrictMode>
                    <FAQs source={source ? parseInt(source) : 0}
                        resultMessage={decodeURI(resultMessage ?? 'Search Results for "[searchTerm]"')}
                        noResultMessage={decodeURI(noResultMessage ?? 'No results found for "[searchTerm]"')} />
                </React.StrictMode>
            );
        }
    });
}

// blog categories
if (document.querySelectorAll('.widget-blog-categories').length) {
    document.querySelectorAll('.widget-blog-categories').forEach(element => {
        if (element.children.length) {
            const childNode = element.children[0];

            // data params
            const title = childNode.getAttribute('data-title');

            const root = ReactDOM.createRoot(
                childNode
            );

            root.render(
                <React.StrictMode>
                    <BlogCategories title={title ?? 'Categories'} />
                </React.StrictMode>
            );
        }
    });
}

// related blog
if (document.querySelectorAll('.widget-related-blog-posts').length) {
    document.querySelectorAll('.widget-related-blog-posts').forEach(element => {
        if (element.children.length) {
            const childNode = element.children[0];

            // data params
            const title = childNode.getAttribute('data-title');
            const id = childNode.getAttribute('data-id');
            const numberOfPosts = childNode.getAttribute('data-numberOfPosts');

            const root = ReactDOM.createRoot(
                childNode
            );

            root.render(
                <React.StrictMode>
                    <RelatedBlogPosts
                        title={title ?? 'Related Blog Posts'}
                        id={id ? parseInt(id) : 0}
                        numberOfPosts={numberOfPosts ? parseInt(numberOfPosts) : 2} />
                </React.StrictMode>
            );
        }
    });
}

// floating features
if (document.querySelectorAll('.widget-floating-features').length) {
    document.querySelectorAll('.widget-floating-features').forEach(element => {
        if (element.children.length) {
            const childNode = element.querySelector('.floating-features-mount');

            if (childNode) {
                const sectionsData = childNode.getAttribute('data-sections');
                let sections: Section[] = [];

                if (sectionsData) {
                    try {
                        sections = JSON.parse(sectionsData);
                    } catch (e) {
                        console.error('Failed to parse floating features data:', e);
                    }
                }

                const root = ReactDOM.createRoot(childNode);

                root.render(
                    <React.StrictMode>
                        <FloatingFeaturesWidget sections={sections} />
                    </React.StrictMode>
                );
            }
        }
    });
}

// carousel
/*if (document.querySelectorAll('.widget-carousel').length) {
    document.querySelectorAll('.widget-carousel').forEach(element => {
        if (element.children.length) {
            const childNode = element.children[0];

            // data params
            const layout = childNode.getAttribute('data-layout');
            const variant = childNode.getAttribute('data-variant');
            const slidesData = childNode.getAttribute('data-slides');
            const imagesData = childNode.getAttribute('data-images');
            const itemsData = childNode.getAttribute('data-items');
            const slidesVisibleOnSmallScreens = childNode.getAttribute('data-small') || childNode.getAttribute('data-slidesVisibleOnSmallScreens');
            const slidesVisibleOnMediumScreens = childNode.getAttribute('data-medium') || childNode.getAttribute('data-slidesVisibleOnMediumScreens');
            const slidesVisibleOnLargeScreens = childNode.getAttribute('data-large') || childNode.getAttribute('data-slidesVisibleOnLargeScreens');
            const auto = childNode.getAttribute('data-autoplay') || childNode.getAttribute('data-auto');
            const autoInterval = childNode.getAttribute('data-autoplay-timeout') || childNode.getAttribute('data-autoInterval');
            const lazyload = childNode.getAttribute('data-lazyload');
            const stagePaddingSmall = childNode.getAttribute('data-stagepadding-small');
            const stagePaddingMedium = childNode.getAttribute('data-stagepadding-medium');
            const stagePaddingLarge = childNode.getAttribute('data-stagepadding-large');

            // Parse the JSON data or convert from DOM data
            let slides, images, items;

            if (slidesData) {
                slides = JSON.parse(slidesData);
            }

            if (imagesData) {
                images = JSON.parse(imagesData);
            } else if (variant === 'Images' || element.className.includes('variant-images')) {
                // Extract images from child divs with class 'carousel-image-item'
                const imageItems = Array.from(childNode.querySelectorAll('.carousel-image-item img'));
                if (imageItems.length > 0) {
                    images = imageItems.map((img, index) => {
                        const imgElement = img as HTMLImageElement;
                        // look for the data-src on the first child
                        const firstChild = imgElement.firstElementChild as HTMLElement | null;
                        const dataSrc = firstChild?.getAttribute('data-src');
                        return {
                            id: index,
                            name: imgElement.alt || `Image ${index}`,
                            url: dataSrc || imgElement.src,
                            width: 800,
                            height: 600,
                            updateDate: new Date(),
                            crops: {
                                crops: [
                                    {
                                        alias: 'thumbnail',
                                        width: 800,
                                        height: 600
                                    }
                                ]
                            }
                        };
                    });
                }
            }

            if (itemsData) {
                items = JSON.parse(itemsData);
            }

            const root = ReactDOM.createRoot(childNode);

            root.render(
                <React.StrictMode>
                    <CarouselWidget
                        slides={slides}
                        images={images}
                        items={items}
                        layout={layout ?? undefined}
                        variant={variant ?? undefined}
                        slidesVisibleOnSmallScreens={slidesVisibleOnSmallScreens ? parseInt(slidesVisibleOnSmallScreens) : 1}
                        slidesVisibleOnMediumScreens={slidesVisibleOnMediumScreens ? parseInt(slidesVisibleOnMediumScreens) : 2}
                        slidesVisibleOnLargeScreens={slidesVisibleOnLargeScreens ? parseInt(slidesVisibleOnLargeScreens) : 5}
                        auto={auto === 'True' || auto === 'true'}
                        autoInterval={autoInterval ? parseInt(autoInterval) : 6000}
                        lazyload={lazyload === 'true' || lazyload === 'True'}
                        stagePaddingSmall={stagePaddingSmall ? parseFloat(stagePaddingSmall) : 0.25}
                        stagePaddingMedium={stagePaddingMedium ? parseFloat(stagePaddingMedium) : 0.25}
                        stagePaddingLarge={stagePaddingLarge ? parseFloat(stagePaddingLarge) : 0.25}
                        className={childNode.className}
                    />
                </React.StrictMode>
            );
        }
    });
}*/
